import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { MyserviceService } from '../myservice.service';
import { saveAs } from "file-saver";
import * as XLSX from 'xlsx';
import * as moment from 'moment';
type AOA = any[][];
@Component({
  selector: 'app-sfg-doc-repo',
  templateUrl: './sfg-doc-repo.component.html',
  styleUrls: ['./sfg-doc-repo.component.css'],
  providers: [MessageService,ConfirmationService],
})
export class SfgDocRepoComponent implements OnInit {
  rowsNo = 10;
  offset: number = 0;
  pageSize: number = 10;
  noOfRecords: number = 0;
  hasSearched = false;
  sortField: String="dateTimeReceived";
  sortOrder: number = -1;
  selectedPartners: any = [];
  count: number = 0;
  show: boolean = false;
  show1: boolean = false;
  transactionArray: any = [];
  selected: { startDate: Date; endDate: Date; };
  loader: boolean;
  searchData: any=[];
  noRecords: boolean;
  filesData: any = [];
  tableHeaders = [
    { field: "", header: "#", width: "2%" },
    { field: "dateTimeReceived", header: "Date Time", width: "4%" },
    { field: "fileId", header: "Instance Id", width: "4%" },
    { field: "producer", header: "Producer", width: "4%" },
    { field: "consumer", header: "Consumer", width: "4%" },
    { field: "direction", header: "Direction", width: "4%" },
    { field: "filename", header: "File Name", width: "6%" },
    { field: "fileStatus", header: "File Status", width: "6%" },
    { field: "reProcessStatus", header: "Reprocess", width: "4%" },
  ];
  directionArray = [{label:"Select", value:"-1"},{ label: "Inbound", value: "INBOUND" }, { label: "Outbound", value: "OUTBOUND" }]
  showPreview: boolean;
  showMail: boolean
  mailData: any;
  producer:any=[];
  consumer:any=[];
  direction:any;
  fileName:any;
  fileStatus:any;
  instanceId:any;
  statusArray: any;
  database:any;
  producerList: any=[];
  consumerList: any=[];
  selectedRowId: any;
  headers: HttpHeaders;
  sendDisable: boolean;
  selectedFilePath: any;
  downloadDisable: boolean;
  fileContent: any="Loading...";
  roleId: any;
  pdfSrc: any;
  pageVariable = 2;
  extention: any;
  csvData: AOA;
  disableExcel: boolean;
  csvLoading: boolean;
  selectedFileName: any;
  userDetails: any;
  dateType :any
  dateTypeList = [
      {label : 'Custom Range' ,value: 'Custom Range'},
      {label : 'Last 30 Days' ,value: 'Last 30 Days'},
      {label : 'Last 7 Days' ,value: 'Last 7 Days'},
      {label : 'Today' ,value: 'Today'},
      {label : 'Yesterday' ,value: 'Yesterday'}
  ]
    alwaysShowCalendars: boolean;
    ranges: any = {
          'Today': [ moment().startOf('day'), moment().endOf('day') ],
          'Yesterday': [ moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
          'Last 7 Days': [ moment().subtract(6, 'days').startOf('day'), moment().endOf('day') ],
          'Last 30 Days': [ moment().subtract(29, 'days').startOf('day'), moment().endOf('day') ],
          'This Month': [ moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day') ],
          'Last Month': [
            moment().subtract(1, 'month').startOf('month').startOf('day'),
            moment().subtract(1, 'month').endOf('month').endOf('day')      
          ]
        };
  
  backendConfig:any;
  constructor(private confirmationService: ConfirmationService,private service: MyserviceService,private fb: FormBuilder, public localstorage: LocalStorageService, 
    private http: HttpClient, public datepipe: DatePipe, private messageService: MessageService,public session: SessionStorageService) { 
    let headers = new HttpHeaders();
    this.headers = headers.append(
        "authorization",
        this.localstorage.retrieve("token")
    );
  }

  ngOnInit() {
    //To get user details
    this.userDetails=this.service.getUserData();
    this.roleId=this.session.retrieve("UserDetails").roleId;
    this.backendConfig = this.session.retrieve('backend_config');
    this.mailData = this.fb.group({
      mails: [[], Validators.required],
      body: ['', Validators.required],
      subject: ['', Validators.required]
    });
    this.statusArray = this.service.getStatus();
    this.setToDefault();
    this.producerList=this.service.getProducer(this.localstorage.retrieve("token"),"LIVE")
    this.consumerList=this.service.getConsumer(this.localstorage.retrieve("token"),"LIVE")
  }
  search(countFlag=false) {
    this.loader=true;
    let data = {
      fromDate: this.selected.startDate != null ? this.datepipe.transform(this.selected.startDate, "MM/dd/yyyy HH:mm") : "-1",
      toDate: this.selected.endDate != null ? this.datepipe.transform(this.selected.endDate, "MM/dd/yyyy HH:mm") : "-1",
      producer: this.service.multiSelectValue(this.producerList,this.producer),
      consumer: this.service.multiSelectValue(this.consumerList,this.consumer),
      fileName:this.fileName?this.fileName:"-1",
      fileStatus: this.fileStatus?this.fileStatus:"-1",
      instanceId: this.instanceId?this.instanceId:"-1",
      direction:this.direction?this.direction:"-1",
      liveOrArchive:this.database,
      limit:this.pageSize,
      offSet:this.offset,
      sortField:this.sortField,
      sortOrder: this.sortOrder == 1 ? "ASC" : "DESC",
      countFlag: countFlag
    }
    this.hasSearched=true;
    this.http.post(
        environment.apiUrl + `/sfg/search`,
        data,
        {
          headers: this.headers,
        }
      )
      .subscribe((data:any) => {
        this.loader=false;
        this.searchData = data.data;
        if (countFlag) {
          this.noOfRecords = data.totalRecordsCount;
        }
        if (data.totalRecordsCount == 0) {
          this.noRecords = true;
        }
      });

  }
  //For server side pagination and sorting
  onPagination(data) {
    this.rowsNo = data.first + data.rows >= this.noOfRecords ? this.noOfRecords : data.first + data.rows;
    //Checking if the previous pagination and sorting fields are different with latest fields or not to reduce the API hits
    if (data.first != this.offset || data.rows != this.pageSize || data.sortField != this.sortField || data.sortOrder != this.sortOrder) {
      this.offset = data.first;
      this.pageSize = data.rows;
      this.sortField = data.sortField;
      this.sortOrder = data.sortOrder;
      this.search();
    }
  }
  dbChange(database) {
    this.producerList = this.service.getProducer(this.localstorage.retrieve("token"), database)
    this.consumerList = this.service.getConsumer(this.localstorage.retrieve("token"), database)
  }
  setDefaultPagination(){
    this.hasSearched = false;
    this.offset = 0;
    this.pageSize = 10;
    this.noOfRecords = 0;
    this.sortField = "dateTimeReceived";
    this.sortOrder = -1;
  }
  setToDefault() {
    this.setDefaultPagination();
    this.database = "LIVE";
    let today = this.service.getDateByTZ();
    this.selected = {
      startDate: new Date(
        today.getUTCFullYear(),
        today.getUTCMonth(),
        today.getUTCDate(),
        0,
        0,
        0
      ),
      endDate: new Date(
        today.getUTCFullYear(),
        today.getUTCMonth(),
        today.getUTCDate(),
        23,
        59,
        0
      ),
    };
    this.producer=[];
    this.consumer=[];
    this.fileName="";
    this.fileStatus="-1";
    this.direction="-1";
    this.instanceId="";
    this.searchData=[]
    this.noRecords=false
  }
  showReproConfirm() {
    if (this.selectedRowId == undefined) {
      this.messageService.add(
        { severity: 'error', summary: 'Error', detail: `Please select one check box` }
      );
  }
  else{
      this.confirmationService.confirm({
      message: 'Are you sure that you want to reprocess?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      key: "positionDialog",
      accept: () => {
          this.reprocess()          
          },
      reject: () => {
      }
  });
  }
}
reprocess(){
        this.http
            .get(
                environment.apiUrl +
                    "/sfg/sfgReprocess?id="+this.selectedRowId,
                { headers: this.headers }
            )
            .subscribe((data) => {
                this.search();
            });
}
mail() {
  if (this.mailData.invalid) {
    if (!this.mailData.get('mails').invalid && !this.mailData.get('body').invalid&&!this.mailData.get('subject').invalid) {
      this.sendMail();
    } else {
      const controls = this.mailData.controls;
      Object.keys(controls).forEach((key) => {
        controls[key].markAsTouched();
      });
    }
  }
  else {
    this.sendMail();
  }
}
sendMail() {
  this.sendDisable=true
  let headers = new HttpHeaders();
  headers = headers.append(
    "authorization",
    this.localstorage.retrieve("token")
  );
  const mailData = {
    "filePath": [this.selectedFilePath+'/'+this.selectedFileName],
    "toAddress": this.mailData.value.mails,
    "body": this.mailData.value.body,
    "subject":this.mailData.value.subject
  }
  this.http
    .post(
      environment.apiUrl + "/sfg/sendMail ",
      mailData,
      {
        headers: headers,
      }
    )
    .subscribe(
      (response: any) => {
        this.messageService.add({
          severity: response.success == true ? "success" : "error",
          detail: response.message,
        });
          this.sendDisable=false;
          this.showMail=false;
      },
    );
 }
  generateExcel() {
    var date = this.service.getDateByTZ()
    this.disableExcel=true;
    let data = {
      fromDate: this.selected.startDate != null ? this.datepipe.transform(this.selected.startDate, "MM/dd/yyyy HH:mm") : "-1",
      toDate: this.selected.endDate != null ? this.datepipe.transform(this.selected.endDate, "MM/dd/yyyy HH:mm") : "-1",
      producer: this.producer,
      consumer: this.consumer,
      fileName:this.fileName?this.fileName:"-1",
      fileStatus: this.fileStatus?this.fileStatus:"-1",
      instanceId: this.instanceId?this.instanceId:"-1",
      liveOrArchive:this.database,
      sortField:this.sortField,
      sortOrder: this.sortOrder == 1 ? "ASC" : "DESC",
      countFlag: false
    }
this.http
    .post(
        environment.apiUrl + "/sfg/download ",
       data,
        {
            responseType: "blob",
            headers: this.headers,
        }
    )
    .subscribe(
        (response: any) => {
          this.disableExcel=false;
            var blob = new Blob([response], {
                type: "application/vnd.ms-excel",
            });
            saveAs(
                blob,
                "DocumentRepositoryReport_" +
                this.datepipe.transform(date, "ddMMyyyy_HHmm","+0000") +
                    ".xlsx"
            );
        },
        (error) => {
          this.disableExcel=false;
            //console.log("Error occured" + error);
        }
    );
  }
  getFileContent(){
    this.extention = this.selectedFileName.split(".")[this.selectedFileName.split(".").length-1];
    this.pdfSrc="";
    this.csvLoading=true;
   this.csvData=<AOA>[]
    this.fileContent="Loading...";
   this.service.sfgFileDownload(this.selectedFilePath+'/'+this.selectedFileName).subscribe((response: any) => {
    this.fileContent=response;
    if (this.extention=='csv'||this.extention=='xlsx') {
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        this.csvData = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
        this.csvLoading=false;
      };
      reader.readAsBinaryString(this.fileContent);
  }
    else if (this.extention=='pdf') {
      let reader = new FileReader();
      let blob = new Blob([this.fileContent], { type: "text/csv" });
        reader.onload = (e: any) => {
          this.pdfSrc = e.target.result;
        };
        reader.readAsArrayBuffer(blob);
    }
    });
  }
  download(){
    this.downloadDisable=true
    let blob = new Blob([this.fileContent], { type: "text/csv" });
    saveAs(blob, this.selectedFileName);
    this.downloadDisable=false
  }
  previewFile(data) {
    this.selectedFilePath=data.sfgPath;
    this.selectedFileName=data.filename;
    this.getFileContent();
    this.mailData.reset()
    this.showPreview = true;
  }
  
  validateEmail(data) {
    if (!(/^\w+([\.-]?\w+)*@rehlko.com+$/.test(data.value) || /^\w+([\.-]?\w+)*@miraclesoft.com+$/.test(data.value))) {
      let mails = this.mailData.value.mails;
      this.mailData.controls.mails.patchValue(mails.slice(0, mails.length - 1))
      this.messageService.add(
        { severity: 'error', summary: 'Error', detail: `${data.value} is not a valid email` }
      );
    }
  }
}


